// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1hmyL","author":"Table_author__3Pa1j","authorImage":"Table_authorImage__E2AnC","unreadRow":"Table_unreadRow__3XzqU"};